import React from 'react'
import classes from './ValidationRules.css'
import FailIcon from 'static/images/icons/close.svg'
import PassIcon from 'static/images/icons/check.svg'

export const ValidationRules = props => {
  const {
    validationTests,
    updatePassword,
    passIcon = <PassIcon />,
    failIcon = <FailIcon />,
    useGridLayout = false
  } = props

  const getClassName = () => {
    if (updatePassword) {
      if (useGridLayout) {
        return 'color-gray'
      }
      return 'color'
    }
    return 'validStatus'
  }

  const getIcon = iconClass => {
    if (iconClass === 'pass') {
      return (
        <span className={classes[iconClass]}>
          { passIcon }
        </span>
      )
    } else {
      return (
        <span className={classes[iconClass]}>
          { failIcon }
        </span>
      )
    }
  }

  const getValidationIcon = tests => {
    let iconClass

    for (let i = 0; i < tests.length; i += 1) {
      const test = tests[i]
      if (validationTests[test]) {
        iconClass = 'pass'
      } else {
        iconClass = 'fail'
        break
      }
    }

    return (
      <span className={classes[getClassName()]}>
        {getIcon(iconClass)}
      </span>
    )
  }
  return (
    <div className={useGridLayout ? [ classes.validationRules, classes.colorSilver ].join(' ') : classes.validationRules}>
      Your password must include:
      <div className={useGridLayout ? classes.validationRulesGrid : null}>
        <div className={classes.rule}>
          {getValidationIcon([ 'validLength', 'noWhitespace' ])}
          8-20 characters (no spaces)
        </div>

        <div className={classes.rule}>
          {getValidationIcon([ 'hasLowercase' ])}
          At least one lower case letter
        </div>

        <div className={classes.rule}>
          {getValidationIcon([ 'hasUppercase' ])}
          At least one upper case letter
        </div>

        <div className={classes.rule}>
          {getValidationIcon([ 'hasNumber' ])}
          At least one number
        </div>
      </div>
    </div>
  )
}

export default ValidationRules



// WEBPACK FOOTER //
// ./src/legacy/components/ValidationRules/ValidationRules.jsx